(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hs-mobile-sticky-atc"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.hsStickyAtcV3) return;
    window.hsStickyAtcV3 = true;
    const initialize = bar => {
      if (bar.dataset.initialized) return;
      bar.dataset.initialized = 'true';
      const info = bar.closest('product-info');
      if (!info) return;
      const sectionId = bar.dataset.sectionId;
      const variants = JSON.parse(bar.querySelector('[data-hs-sticky-variants]').textContent);
      const purchase = info.querySelector('.hs-pdp-purchase');
      if (!purchase) return;
      const button = bar.querySelector('[data-hs-sticky-submit]');
      const mobile = window.matchMedia('(max-width:749px)');
      let pastPurchase = false;
      const visibility = () => {
        const visible = pastPurchase && mobile.matches && !document.querySelector('dialog[open]');
        bar.classList.toggle('is-visible', visible);
        bar.inert = !visible;
        bar.setAttribute('aria-hidden', String(!visible));
        document.body.classList.toggle('hs-has-mobile-atc', visible);
      };
      const sync = () => {
        const input = document.querySelector('#product-form-' + sectionId + ' input[name="id"]');
        const original = document.getElementById('ProductSubmitButton-' + sectionId);
        const variant = variants.find(item => String(item.id) === String(input?.value));
        if (!variant || !original) {
          button.disabled = true;
          return;
        }
        const variantLabel = bar.querySelector('[data-hs-sticky-variant]');
        const price = bar.querySelector('[data-hs-sticky-price]');
        if (variantLabel.textContent !== variant.title) variantLabel.textContent = variant.title;
        if (price.textContent !== variant.price) price.textContent = variant.price;
        button.disabled = !variant.available || original.disabled || original.getAttribute('aria-disabled') === 'true';
        const label = variant.available ? bar.dataset.addLabel : bar.dataset.soldOutLabel;
        if (button.textContent.trim() !== label) button.textContent = label;
        button.setAttribute('aria-busy', String(original.classList.contains('loading')));
      };
      button.addEventListener('click', () => {
        const original = document.getElementById('ProductSubmitButton-' + sectionId);
        if (original && !original.disabled && original.getAttribute('aria-disabled') !== 'true') {
          original.click();
          sync();
        }
      });
      info.addEventListener('change', () => window.requestAnimationFrame(sync));
      new MutationObserver(sync).observe(purchase, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'], childList: true, subtree: true });
      new IntersectionObserver(([entry]) => {
        pastPurchase = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        visibility();
      }).observe(purchase);
      mobile.addEventListener('change', visibility);
      document.addEventListener('toggle', visibility, true);
      const attach = () => {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (String(data.sectionId) === String(sectionId)) sync();
          });
        }
        sync();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, { once: true });
      else attach();
      visibility();
    };
    const hydrate = root => root.querySelectorAll('[data-hs-mobile-atc]').forEach(initialize);
    hydrate(document);
    document.addEventListener('shopify:section:load', event => hydrate(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-size-assist"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.hsSizeAssistV3) return;
    window.hsSizeAssistV3 = true;
    const update = root => {
      const info = root.closest('product-info');
      if (!info) return;
      const name = root.dataset.optionName;
      const controls = Array.from(info.querySelectorAll('variant-selects input, variant-selects select'));
      const control = controls.find(item => {
        const matches = item.dataset.optionName === name || item.name === 'options[' + name + ']' || item.name === name || item.name.startsWith(name + '-');
        return matches && (item.type !== 'radio' || item.checked);
      });
      if (!control) return;
      const output = root.querySelector('[data-hs-size-value]');
      if (output && output.textContent !== control.value) output.textContent = control.value;
      root.querySelectorAll('.hs-size-dialog__sizes span').forEach(item => item.classList.toggle('is-selected', item.textContent.trim() === control.value));
    };
    document.addEventListener('click', event => {
      const opener = event.target.closest('[data-hs-size-open]');
      if (opener) {
        update(opener.closest('[data-hs-size-assist]'));
        const dialog = document.getElementById(opener.getAttribute('aria-controls'));
        dialog?.showModal();
      }
      const closer = event.target.closest('[data-hs-size-close]');
      if (closer) closer.closest('dialog')?.close();
      if (event.target.matches('[data-hs-size-dialog]')) event.target.close();
    });
    document.addEventListener('change', event => {
      const info = event.target.closest('product-info');
      info?.querySelectorAll('[data-hs-size-assist]').forEach(update);
    });
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hs-size-assist]').forEach(update));
    const attach = () => {
      document.querySelectorAll('[data-hs-size-assist]').forEach(update);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          document.querySelectorAll('product-info[data-section="' + data.sectionId + '"] [data-hs-size-assist]').forEach(update);
        });
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, { once: true });
    else attach();
  })();
  } catch(e) { console.error(e); }
})();

})();
